import { Rive } from "@rive-app/canvas";
import { debounce } from "../utilities/_throttleDebounce"

const rive = {
	riveInstances: {},

	init() {
		this.initRiveCanvases()
	},

	initRiveCanvases() {
		const self = this;

		const canvasElements = document.querySelectorAll("canvas[data-url]")

		if (canvasElements.length !== null) {
			canvasElements.forEach((canvas) => {
				const fileURL = canvas.dataset.url
				const canvasID = canvas.id
				const desktopUp = canvas.hasAttribute('data-desktop-up')
				const desktopDown = canvas.hasAttribute('data-desktop-down')

				const shouldInitialize = () => {
					const windowWidth = window.innerWidth
					if (desktopUp && windowWidth < 768) return false
					if (desktopDown && windowWidth >= 768) return false
					return true
				};

				const initializeRive = () => {
					if (fileURL) {
						const riveInstance = new Rive({
							src: fileURL,
							canvas: canvas,
							autoplay: true,
							clearCanvas: false,
							background: "transparent",
							stateMachines: ["State Machine 1"],
							onLoad: () => {
								riveInstance.resizeDrawingSurfaceToCanvas()
								self.riveInstances[canvasID] = riveInstance
							},
						});
					} else {
						console.error(`No Rive URL provided for canvas ID "${canvasID}"`)
					}
				};

				const destroyRive = () => {
					if (self.riveInstances[canvasID]) {
						self.riveInstances[canvasID].cleanup()
						delete self.riveInstances[canvasID]
					}
				};

				// Initialise
				//
				if (shouldInitialize()) {
					initializeRive()
				}

				// Resize handling with debounce and width checks
				//
				let initialWidth = window.innerWidth;

				window.addEventListener("resize", debounce(function() {
					const currentWidth = window.innerWidth

					if (currentWidth !== initialWidth) {
						initialWidth = currentWidth

						destroyRive()

						setTimeout(() => {
							if (shouldInitialize()) {
								if (!self.riveInstances[canvasID]) {
									initializeRive()
								}
							}
						}, 250)
					}
				}, 500))
			});
		}
	}
}

window.addEventListener("load", function() {
	rive.init()
})
